import { MEDIA_BUNDLE_PREFIX, MEDIA_BUNDLE_SUFFIX } from '../constants';

export const isPreviewableMime = (type = '') =>
    (type.startsWith('image/') && type !== 'image/svg+xml') || type.startsWith('video/');

const UPLOAD_URL_RE = /^\/uploads\/[^?#]+$/;
const DOWNLOAD_URL_RE = /^\/api\/upload-download\/[^#]+$/;
const toDimension = (v) => (Number.isInteger(v) && v > 0 && v < 100000 ? v : undefined);

// 메시지 본문은 누구나 조작할 수 있으므로, 우리 서버 업로드 경로를 가리키는 항목만 통과시킨다
export const normalizeMediaFile = (file) => {
    if (!file || typeof file !== 'object') return null;
    const { fileUrl, downloadUrl, originalName, mimetype } = file;
    if (typeof fileUrl !== 'string' || !UPLOAD_URL_RE.test(fileUrl)) return null;
    if (typeof mimetype !== 'string' || !isPreviewableMime(mimetype)) return null;
    return {
        fileUrl,
        downloadUrl: typeof downloadUrl === 'string' && DOWNLOAD_URL_RE.test(downloadUrl) ? downloadUrl : null,
        originalName: String(originalName || 'file').slice(0, 255),
        mimetype,
        width: toDimension(file.width),
        height: toDimension(file.height),
    };
};

export const isMediaBundle = (message) => typeof message === 'string' && message.startsWith(MEDIA_BUNDLE_PREFIX);

export const parseMediaBundle = (message) => {
    if (!isMediaBundle(message)) return null;
    try {
        const list = JSON.parse(message.slice(MEDIA_BUNDLE_PREFIX.length, message.length - MEDIA_BUNDLE_SUFFIX.length));
        const files = Array.isArray(list) ? list.slice(0, 50).map(normalizeMediaFile).filter(Boolean) : [];
        return files.length ? files : null;
    } catch { return null; }
};

export const buildMediaBundle = (files) => `${MEDIA_BUNDLE_PREFIX}${JSON.stringify(files.map(f => ({
    fileUrl: f.fileUrl, downloadUrl: f.downloadUrl, originalName: f.originalName, mimetype: f.mimetype,
    ...(f.width && f.height ? { width: f.width, height: f.height } : {}),
})))}${MEDIA_BUNDLE_SUFFIX}`;

// 같은 이름 파일을 zip 에 넣으면 덮어써지므로 "이름 (2).jpg" 형태로 구분
export const uniqueFileNames = (names) => {
    const used = new Map();
    return names.map((raw) => {
        // eslint-disable-next-line no-control-regex
        const name = String(raw || 'file').replace(/[\\/:*?"<>|\x00-\x1F]/g, '_').replace(/^\.+/, '_') || 'file';
        const count = used.get(name.toLowerCase()) || 0;
        used.set(name.toLowerCase(), count + 1);
        if (!count) return name;
        const dot = name.lastIndexOf('.');
        return dot > 0 ? `${name.slice(0, dot)} (${count + 1})${name.slice(dot)}` : `${name} (${count + 1})`;
    });
};

export const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, ch => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
}[ch]));
